import * as THREE from 'three';
import gsap from 'gsap';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import Model from './model';

/*------------------------------
Renderer
------------------------------*/
const renderer = new THREE.WebGLRenderer({
  antialias: true,
  alpha: true
});
renderer.setSize(window.innerWidth, window.innerHeight);
document.body.appendChild(renderer.domElement);

/*------------------------------
Scene & Camera
------------------------------*/
const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(
  50,
  window.innerWidth / window.innerHeight,
  0.1,
  100
);
camera.position.z = 5;
camera.position.y = 1;

/*------------------------------
Controls
------------------------------*/
const controls = new OrbitControls(camera, renderer.domElement);
controls.enabled = false;

/*------------------------------
Cow Model
------------------------------*/
const cow = new Model({
  name: 'cow',
  color1: 'blue',
  color2: 'red',
  background: '#000',
  file: './models/cow.glb',
  scene: scene,
  placeOnLoad: true
});

/*------------------------------
Animation Loop
------------------------------*/
const clock = new THREE.Clock();
function animate() {
  requestAnimationFrame(animate);
  renderer.render(scene, camera);

  if (cow.isActive) {
    cow.particlesMaterial.uniforms.uTime.value = clock.getElapsedTime();
  }
}
animate();

/*------------------------------
Resize
------------------------------*/
window.addEventListener('resize', () => {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
});

/*------------------------------
Mouse Move Rotation
------------------------------*/
window.addEventListener('mousemove', (e) => {
  const x = e.clientX;
  const y = e.clientY;

  gsap.to(scene.rotation, {
    y: gsap.utils.mapRange(0, window.innerWidth, -0.5, 0.5, x),
    x: gsap.utils.mapRange(0, window.innerHeight, -0.5, 0.5, y)
  });
});